var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectstarDark = function SvgSelectstarDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.002 20.355-5.662 9.671-4.676-2.663 5.66-9.675H0v-5.323h11.325L5.664 2.69 10.34.026l5.662 9.671 5.66-9.67 4.676 2.663-5.66 9.675H32v5.323H20.677l5.661 9.675-4.676 2.663z"
  })));
};
export default SvgSelectstarDark;